<template>
    <div>
        <b-modal id="create-system-user" title="Sistem Kullanıcısı Oluştur" no-close-on-esc no-close-on-backdrop>
            <create-system-user v-model="systemUser"></create-system-user>
            <template #modal-footer><v-executer :loading="userCreating" text="Oluştur" :action="createSystemUser"></v-executer></template>
        </b-modal>

        <b-modal id="warnings" title="Uyarılar" body-class="p-75" hide-footer>
            <employee-warning v-model="warnings"></employee-warning>
        </b-modal>

        <b-modal id="estimated-score" size="lg" title="Tahmini Aylık Puantaj" body-class="p-50" hide-footer>
            <estimated-score :id="id"></estimated-score>
        </b-modal>

        <div class="d-flex align-items-center mb-1">
            <button class="btn btn-sm btn-dark" v-on:click="back"><feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri</button>
            <b-badge v-if="isCandidate" variant="warning" class="ml-1">Aday Personel</b-badge>
            <div class="d-flex align-items-center ml-auto">
                <button class="btn btn-success mr-1 btn-sm" v-if="isCandidate && editing" v-on:click="convertToEmployee" :disabled="converting">
                    <feather-icon icon="UserCheckIcon" class="mr-25"></feather-icon>
                    Gerçek Personele Dönüştür
                </button>
                <button class="btn btn-secondary mr-1 btn-sm" v-if="hasWarning" v-on:click="showWarning">
                    <feather-icon icon="AlertOctagonIcon"></feather-icon>
                    Uyarılar
                </button>
                <b-dropdown variant="dark" size="sm" text="İşlemler" right :disabled="loading" v-if="!isCandidate">
                    <b-dropdown-item v-on:click="$showModal('create-system-user')" :disabled="info.HasUser">Sistem Kullanıcısı Oluştur</b-dropdown-item>
                    <b-dropdown-item v-on:click="$showModal('estimated-score')">Tahmini Aylık Puantaj</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <div class="mb-1" v-if="editing">
            <employee-profile :info="viewedInfo" :has-warning="hasWarning" :employee-branch="employeeBranch" :sgk-entry="sgkEntry" :show-email-warning="showEmailWarning"></employee-profile>
        </div>
        <b-overlay :show="loading" opacity="0.2" rounded="sm">
            <b-card class="p-0" no-body>
                <b-tabs v-model="tab" v-on:input="change" pills nav-class="pt-1 px-1" active-nav-item-class="nav-pill-secondary" content-class="mt-1 border-top">
                    <b-tab title="Özlük Bilgileri" active>
                        <employee-personnel-info :editing="editing" v-model="info" :get-personal="getPersonal" :employee-loaded="employeeLoaded" :candidate="isCandidate"></employee-personnel-info>
                    </b-tab>
                    <b-tab :title="getOtherInfoTitle('Diğer Özlük Bilgileri')" :disabled="!editing">
                        <employee-other-personnel-info :unsaved="controlUnsavedChanges" v-model="otherInfo" :id="id" :get-personal="getPersonal" :candidate="isCandidate" v-on:email-updated="handleEmailUpdated" ></employee-other-personnel-info>
                    </b-tab>
                    <b-tab title="Ehliyet Bilgileri" :disabled="!editing">
                        <employee-driver-license-info v-model="driverLicenseInfo" :id="id" :is-driver="isDriver" :get-personal="getPersonal" :candidate="isCandidate"></employee-driver-license-info>
                    </b-tab>
                    <b-tab title="Dosyalar" lazy :disabled="!editing" v-if="!isCandidate">
                        <employee-all-files :id="id" :code="businessAgreement.CollarStatusCode"></employee-all-files>
                    </b-tab>
                    <!-- <b-tab title="Belgeler" :disabled="!editing">
                        <employee-documents :id="id" ref="docs"></employee-documents>
                    </b-tab>
                    <b-tab title="Sicil Dosyası" :disabled="!editing">
                        <employee-registry-file :id="id" :code="businessAgreement.CollarStatusCode"></employee-registry-file>
                    </b-tab> -->
                    <b-tab title="İş Sözleşmesi" :disabled="!editing" lazy v-if="!isCandidate">
                        <employee-business-agreement
                            ref="businessAgreement"
                            :id="id"
                            :candidate="isCandidate"
                            :salary="salary"
                            :business-agreement="businessAgreement"
                            :get-personal="getPersonal"
                            :salaries="salaries"
                            :can-branch-assignable="canExit"
                            :employee-branch="employeeBranch"
                            :can-entry="canEntry"
                            :can-exit="canExit"
                            :sgk-entry-notice="sgkEntryNotice"
                            :sgk-exit-notice="sgkExitNotice"
                            :info="info"
                            :sgk-entry="sgkEntry"
                            :is-driver="isDriver"
                            v-on:exit-done="exitDone"
                            v-on:collar-status-updated="handleCollarStatusUpdated"
                        ></employee-business-agreement>
                    </b-tab>
                    <!-- <b-tab title="Bakiye" lazy>
                        <employee-balance :id="id"/>
                    </b-tab> -->
                    <!-- <b-tab title="KYKM'ler" :disabled="!editing">
                        <employee-salary-effect :id="id" :get-personal="getPersonal"></employee-salary-effect>
                    </b-tab> -->
                    <!-- <b-tab title="Netsis" :disabled="!editing">
                        <employee-netsis-info v-model="netsis" :id="id" :branch="employeeBranch" :is-minimum-wage="sgkSalary.IsMinimumWage" :aktif-netsis-sube="aktifNetsisSube" :get-personal="getPersonal" :sgk-salary="sgkSalary"></employee-netsis-info>
                    </b-tab> -->
                </b-tabs>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import { BCard, BTabs, BTab, BOverlay, BDropdown, BDropdownItem, BBadge } from "bootstrap-vue";
import EmployeePersonnelInfo from "./components/step-1/EmployeePersonnelInfo.vue";
import EmployeeOtherPersonnelInfo from "./components/step-2/EmployeeOtherPersonnelInfo.vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import EmployeeProfile from "./components/EmployeeProfile.vue";
import EmployeeDriverLicenseInfo from "./components/step-3/EmployeeDriverLicenseInfo.vue";
import EmployeeDocuments from "./components/step-4-d/EmployeeDocuments.vue";
import EmployeeRegistryFile from "./components/step-5-d/EmployeeRegistryFile.vue";
import EmployeeBusinessAgreement from "./components/step-6/EmployeeBusinessAgreement.vue";
import EmployeeSalaryEffect from "./components/step-7/EmployeeSalaryEffect.vue";
import EmployeeNetsisInfo from "./components/step-8/EmployeeNetsisInfo.vue";
import EmployeeWarning from "./components/EmployeeWarning.vue";
import CreateSystemUser from "./components/CreateSystemUser.vue";
import EstimatedScore from "./components/EstimatedScore.vue";
import UserApi from "@/api/user";
import moment from "moment";
import EmployeeAllFiles from "./components/step-files/EmployeeAllFiles.vue";

export default {
    components: {
        BCard,
        BTabs,
        BTab,
        EmployeePersonnelInfo,
        EmployeeOtherPersonnelInfo,
        EmployeeProfile,
        EmployeeDriverLicenseInfo,
        EmployeeDocuments,
        EmployeeRegistryFile,
        EmployeeBusinessAgreement,
        EmployeeSalaryEffect,
        CreateSystemUser,
        EmployeeWarning,
        EstimatedScore,
        BDropdown,
        BDropdownItem,
        BOverlay,
        EmployeeNetsisInfo,
        EmployeeAllFiles,
        BBadge,
    },
    data() {
        return {
            loading: false,
            userCreating: false,
            converting: false,
            tab: 0,
            employeeLoaded: false,
            info: {
                File: null,
                IdentityNumber: null,
                RegistrationCode: null,
                DisabledPerson: null,
                PartTime: false,
                DisabilityRate: 0,
                FirstName: null,
                LastName: null,
                BirthDate: null,
                Gender: null,
                HasUser: null,
                IdentityDocumentSerialNumber: null,
                IsTcCitizen: true,
                NameOfMother: null,
                NameOfFather: null,
                MaritialStatusId: null,
                DateOfMarriage: null,
                BirthCountryId: null,
                BirthProvinceId: null,
                BloodGroupId: null,
                AdditionalInformation: null,
                WorkingGroupId: null,
                WaitingExitDate: null,
            },
            otherInfo: {
                EmployeeRelativeInformations: [],
                EmployeeAddresses: [],
                EmployeeSizeInformations: [],
                EmployeeBankAccounts: [],
                EmployeeContactInfos: [],
                Passports: [],
                Visas: [],
                EducationsOfEmployee: [],
                MilitaryTitlesOfEmployee: [],
            },
            netSalary: {
                CreateTime: null,
                Date: null,
                Month: null,
                Year: null,
                SGK: null,
                Salary: null,
                SalaryStr: null,
                CurrencyUnitId: null,
                CurrencyUnitName: null,
                CurrencyUnitCurrencyCode: null,
                UCRET_NEVI: null,
                SalaryTypeName: null,
                IsMinimumWage: false,
            },
            sgkSalary: {
                CreateTime: null,
                Date: null,
                Month: null,
                Year: null,
                SGK: null,
                Salary: null,
                SalaryStr: null,
                CurrencyUnitId: null,
                CurrencyUnitName: null,
                CurrencyUnitCurrencyCode: null,
                UCRET_NEVI: null,
                SalaryTypeName: null,
                IsMinimumWage: false,
            },
            salary: {
                net: {
                    CreateTime: null,
                    Date: null,
                    Month: null,
                    Year: null,
                    SGK: null,
                    Salary: null,
                    SalaryStr: null,
                    CurrencyUnitId: null,
                    CurrencyUnitName: null,
                    CurrencyUnitCurrencyCode: null,
                    UCRET_NEVI: null,
                    SalaryTypeName: null,
                    IsMinimumWage: false,
                },
                sgk: {
                    CreateTime: null,
                    Date: null,
                    Month: null,
                    Year: null,
                    SGK: null,
                    Salary: null,
                    SalaryStr: null,
                    CurrencyUnitId: null,
                    CurrencyUnitName: null,
                    CurrencyUnitCurrencyCode: null,
                    UCRET_NEVI: null,
                    SalaryTypeName: null,
                    IsMinimumWage: false,
                },
            },
            businessAgreement: {
                SGKBranchId: null,
                ExpenseLocationId: null,
                CollarStatusId: null,
                CollarStatusCode: null,
                RegistrationCode: null,
                SGKRegistryNumber: null,
                SGKInsuranceType: null,
                GarageSalaryString: null,
                BES: false,
                BESLastCheck: null,
                Yol: null,
                Yemek: null,
                Destek: null,
                DestekAmount: null,
            },
            sgkEntryNotice: {
                NotifyDate: null,
                SGK: false,
                ayniIsverenFarkliIsyeriNakil: false,
                nakilGeldigiIsyeriSicil: null,
                branchId: null,
                OccupationTitleId: null,
                sigortalituru: null,
                gorevkodu: null,
                meslekkodu: null,
                csgbiskolu: null,
                eskihukumlu: false,
                ozurlu: false,
                ogrenimkodu: null,
                mezuniyetbolumu: null,
                mezuniyetyili: null,
                kismiSureliCalisiyormu: false,
                kismiSureliCalismaGunSayisi: 0,
                iseGirisTarihi: null,
            },
            sgkExitNotice: {
                SGK: false,
                BranchTransfer: null,
                TransferBranchId: null,
                nakilGidecegiIsyeriSicil: null,
                branchId: null,
                istenCikisTarihi: null,
                istenCikisNedeni: "00",
                SGKParameterId: null,
                JobExitSpecialCauseIds: [],
                ParentJobExitSpecialCauseId: null,
                meslekkodu: null,
                csgbiskolu: null,
                JobExitCauseId: null,
                JobExitCauseCode: null,
                IhbarOneliKullanacak: false,
                IhbarOneliSuresi: null,
                IhbarOneliWorkDay: null,
                Ihtar: false,
                IhtarFile: null,
                Vukuat: false,
                VukuatAciklama: null,
                NotifyDate: null,
                Harmful: false,
                HarmfulReason: null,
                // HerSeyDahil 2. adımda (Hakediş Ön İnceleme) seçilir; 1. adım formunda tutulmaz.
                SirketeBorcuBankaTipi: null,
                AFOK: null,
                EYT: false,
                exitTaskId: null,
                InTheApprovalProcess: false,
                exitTaskIhtarFilePath: null,
                exitTaskIhtarFileDeleted: false,
                bulundugumuzDonem: {
                    belgeturu: 0,
                    hakedilenucret: 0,
                    primikramiye: 0,
                    eksikgunsayisi: 0,
                    eksikgunnedeni: 0,
                },
                oncekiDonem: {
                    belgeturu: 0,
                    hakedilenucret: 0,
                    primikramiye: 0,
                    eksikgunsayisi: 0,
                    eksikgunnedeni: 0,
                },
            },
            sgkEntry: null,
            salaries: { net: [], sgk: [] },
            driverLicenseInfo: {
                Id: null,
                EmployeeId: null,
                DriverLicenseNumber: null,
                DriverLicenseIssueProvinceId: null,
                DriverLicenseIssueProvinceName: null,
                DigitalLicenseNumber: null,
                DocumentSerialNumber: null,
                EmployeeDriverLicenseClassInformations: [],
                ValidityStartDate: null,
                ValidityEndDate: null,
                DigitalLicenseValidityStartDate: null,
                DigitalLicenseValidityEndDate: null,
            },
            employeeBranch: {
                Current: null,
                Id: null,
                Date: null,
                ChangeType: 0,
                BranchId: null,
                EmployeeDepartmentTitleId: null,
                VehicleInventoryGarageId: null,
                EmployeeId: null,
                BranchStartDate: null,
                TitleStartDate: null,
                GarageStartDate: null,
            },
            aktifNetsisSube: null,
            warnings: [],
            viewedInfo: null,
            systemUser: { RoleGroupId: null },
            netsis: {
                SSK_DURUM: null,
                EMEK_NO: null,
                GRUP: null,
                ASKERLIKTIP: null,
                ESKIHUKUMLU: 0,
                HUKUMACIKLAMA: null,
                HUKUMKATEGORI: null,
                TERORLEMUCADELE: 0,
                GOCMEN: 0,
                DENEMESURESI: null,
                COCUK_ADEDI: 0,
                OKUL_ONCESI_COCUK: 0,
                ILKOKUL_COCUK: 0,
                ORTA_COCUK: 0,
                LISE_COCUK: 0,
                YUKSEK_COCUK: 0,
                CARIMUHKOD: null,
                SICUCRETI: null,
                SICUCRET_NEVI: null,
                SICNETI: null,
                SICNETTENGIT: null,
                SICDOVIZ_MAAS: null,
                SICDOVIZ_CINSI: null,
                SICGV_KUM: null,
                SICGV_MAT: null,
                SICKES_KUM_ISCI: null,
                SICKES_KUM_ISVR: null,
                SICKES_KUM_AY: null,
                SICOZELINDMAT: null,
                SICOZELINDGV: null,
                SICFATTUT: null,
                SICTAS_VAR: null,
                SICKALANIND: null,
                SICSSKKANUN: null,
                SICSSKBELGE: null,
                GECINDORAN: null,
                GV_TERKIN: null,
                ISVR_TERKIN: null,
                YEDEK1_TERKIN: null,
                YEDEK2_TERKIN: null,
                K5763_M20_TERKIN: null,
                K5763_M24_TERKIN: null,
                ARGE_CALISMA_SURE: null,
                ARGE_MUAF_ORAN: null,
                K5921_GM9_TERKIN: null,
                K6111_GM10_TERKIN: null,
                K6111_GM10_TERKIN_TARIH: null,
                K6111_GM10_TERKIN_SURE: 0,
                K5921_EM2_TERKIN: null,
                EKKIDEMGUNSAY: null,
                K6486_TERKIN: null,
                ARGE_DAMGAMUAF_ORAN: null,
                K6322_TERKIN_ISVEREN: null,
                K6322_TERKIN_ISCI: null,
                K6322_GV_TERKIN: null,
                K6645_TERKIN: null,
                KHK687_SGK_TERKIN: null,
                KHK687_GV_TERKIN: null,
                KHK687_DV_TERKIN: null,
                K4447_GM19_TERKIN: null,
                K4447_GM19_TERKIN_TARIH: null,
                K4447_GM19_TERKIN_SURE: null,
                SSK_ISZ_ISVR_TESVIK: null,
                K7166_M8_TERKIN: null,
                K7166_M8_TERKIN_TARIH: null,
                K7166_M8_TERKIN_SURE: null,
                SICASGARI_UCRETLI: null,
                SICUCUS_GOR: null,
                SICBORDRO_SIFRE: null,
                K4447_GM26_TERKIN: null,
                K4447_GM26_TERKIN_TARIH: null,
                K4447_GM26_TERKIN_SURE: 0,
                K4447_GM26_TERKIN_GUN: 0,
                DEGISENDEGER: null,
                K7256_M28_TERKIN: null,
                K7256_M28_TERKIN_TARIH: null,
                K7256_M28_TERKIN_SURE: 0,
                K4447_M30_TERKIN: null,
                K4447_M30_TERKIN_TARIH: null,
                K4447_M30_TERKIN_SURE: null,
                K4447_M30_DAHIL: null,
                SICASGKUMGV_MAT: null,
                SICASGGV_IND: null,
                SICASGDV_IND: null,
                HESAPKODU: null,
                TAS_VAR: null,
                TASGERI: null,
                SENDIKA: null,
                ISCI_MEMUR: "I",
                KES_DEV_ISCI: null,
                KES_DEV_ISVR: null,
                KES_DEV_MAT: null,
                DEV_IZIN_GUN: null,
                DEV_NORMAL_GUN: null,
                DEV_NORMAL_MAT: null,
                DEV_IZIN_MAT: null,
                DEV_NORMAL_IMA: null,
                DEV_IZIN_IMA: null,
                DEV_SSK_ISCI_NORM: null,
                DEV_SSK_ISVR_NORM: null,
                DEV_SSK_ISCI_IZIN: null,
                DEV_SSK_ISVR_IZIN: null,
                NETI: null,
                NETTENGIT: null,
                TERSBAKIYE: null,
                YUVARLAMAFARKI: null,
                GV_KUM: null,
                GV_MAT: null,
                BRUT_KUM: null,
                KONUT_FONU: null,
                KONUT_AY_SAY: null,
                KES_KUM_ISCI: null,
                KES_KUM_ISVR: null,
                KES_KUM_AY: null,
                OZELINDMAT: null,
                OZELINDGV: null,
                FATTUT: null,
                KALANIND: null,
                BORCU: null,
                BORCTAK: null,
                BORCFAIZ: null,
                DEV_MADEN_GUN: null,
                DEV_MADEN_MAT: null,
                DEV_MADEN_IMA: null,
                DEV_MADEN_ISCI: null,
                DEV_MADEN_ISVR: null,
                ILKISYERI: null,
                ILKSICILNO: null,
                DOGRUDANGIDER: null,
                SSKKANUN: null,
                SSKBELGE: null,
                GV_COCUK_ADEDI: 0,
                GV_OKUL_ONCESI_COCUK: 0,
                GV_ILKOKUL_COCUK: 0,
                GV_ORTA_COCUK: 0,
                GV_LISE_COCUK: 0,
                GV_YUKSEK_COCUK: 0,
                SSK_COCUK_ADEDI: 0,
                SSK_OKUL_ONCESI_COCUK: 0,
                SSK_ILKOKUL_COCUK: 0,
                SSK_ORTA_COCUK: 0,
                SSK_LISE_COCUK: 0,
                SSK_YUKSEK_COCUK: 0,
                GV_AILE: null,
                SSK_AILE: null,
                IND_DILEK: 0,
                DEV_SSK_ISVR_UCRET: null,
                DEV_SSK_ISVR_IKRAMIYE: null,
                DEV_SSK_ISC_UCRET: null,
                DEV_SSK_ISC_IKRAMIYE: null,
                DEV_BIRAYONCEDEN_SARF: null,
                DEV_IKIAYONCEDEN_SARF: null,
                DEV_K5510M80_SARKAN: null,
                DEV_SSK_TABI_UCRET: null,
                DEV_SSK_TABI_YARDIM: null,
                DEV_ARGE_TERKIN_TUTAR: null,
                ARGE_GV_MAT: null,
                ARGE_ISTISNA_MAT: null,
                DEV_ARGE_GUN: null,
                DEV_SSK_TABI_MADEN_UCRET: null,
                DEV_SSK_TABI_IZIN_UCRET: null,
                DEV_BIRAYONCEDEN_NET_SARF: null,
                DEV_IKIAYONCEDEN_NET_SARF: null,
                DEV_K5510M80_NET_SARKAN: null,
                DEV_SSK_TABI_NET_YARDIM: null,
                DEV_NETEEKLENECEKSARKANTUTAR: null,
                K5921_GM9_TERKIN_TUTAR: null,
                ARGE_GV_TERKIN_TUTAR: null,
                DERECE1_YAKIN_SAYISI: null,
                DERECE2_YAKIN_SAYISI: null,
                DERECE3_YAKIN_SAYISI: null,
                DEV_ARGE_K5510M80_SARKAN: null,
                DEV_ARGE_SSK_TABI_YARDIM: null,
                DEV_ARGE_BIRAYONCEDEN_SARF: null,
                DEV_ARGE_IKIAYONCEDEN_SARF: null,
                K6111_GM10_TERKIN_TUTAR: null,
                K5921_EM2_TERKIN_TUTAR: null,
                MUHREFKOD: null,
                K6486_TERKIN_TUTAR: null,
                ARGE_DV_TERKIN: null,
                K6322_TERKIN_ISVEREN_TUTAR: null,
                K6322_TERKIN_ISCI_TUTAR: null,
                K6322_GV_TERKIN_TUTAR: null,
                K6645_TERKIN_TUTAR: null,
                KHK687_TERKIN_TUTAR: null,
                KHK687_GV_TERKIN_TUTAR: null,
                KHK687_DV_TERKIN_TUTAR: null,
                K4447_GM19_TERKIN_TUTAR: null,
                K4447_GM19_GV_TERKIN_TUTAR: null,
                K4447_GM19_DV_TERKIN_TUTAR: null,
                K4447_GM19_TERKIN_HARIC: null,
                K4447_GM19_TERKIN_ISZ_TUTAR: null,
                K7166_M8_TERKIN_TUTAR: null,
                ASGARI_UCRETLI: null,
                UCUS_GOR: null,
                UCUSGOR_GVIND: null,
                UCUSGOR_DVIND: null,
                BORDRO_SIFRE: null,
                K4447_GM26_ISSIZLIK_TUTAR: null,
                K4447_GM26_SGK_TUTAR: null,
                K4447_GM26_HESAPLANAN_GUN: null,
                K7256_M28_TERKIN_TUTAR: null,
                K4447_M30_TERKIN_TUTAR: null,
                K4447_M30_ISZTER_TUTAR: null,
                DEVUZAKCALISMAGUN: null,
                DEVARGEUZAKCALGUN: null,
                ASGKUMGV_MAT: null,
                ASGGV_IND: null,
                ASGDV_IND: null,
                TAS_HESNO: null,
                EMEKLILIK_TARIHI: null,
                SAKATLIK_DERECE: 0,
                S_YEDEK2: null,
            },
        };
    },
    watch: {
        "info.DisabledPerson"() {
            this.sgkEntryNotice.ozurlu = this.info.DisabledPerson;
        },
        "businessAgreement.SGKInsuranceType"() {
            this.sgkEntryNotice.sigortalituru = this.businessAgreement.SGKInsuranceType;
        },
    },
    created() {
        const tab = Number(this.$route.query.section || 0);
        this.$nextTick(() => {
            this.tab = tab;
        });
    },
    mounted() {
        this.getPersonal();
    },
    methods: {
        change() {
            this.$router.push({ path: this.$route.path, query: { ...this.$route.query, section: this.tab } }).catch(() => {});
        },
        handleCollarStatusUpdated(collarStatus) {
            if(this.viewedInfo) {
                this.viewedInfo.CollarStatus = collarStatus
            }
            
            this.businessAgreement.CollarStatusId = collarStatus.Id
            this.businessAgreement.CollarStatusCode = collarStatus.Code
            
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },

        handleEmailUpdated() {
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },
        
        removeEmailWarning() {
            const index = this.warnings.findIndex(w => w.includes('e-posta'))
            if(index > -1) {
                this.warnings.splice(index, 1)
            }
        },
        getPersonal() {
            if (this.isCandidate) {
                this.getCandidate();
                return;
            }
            if (this.id != "0" || this.id != 0) {
                this.loading = true;
                EmployeeOperationsApi.Employee.Get(this.id)
                    .then((res) => {
                        try {
                            this.employeeLoaded = true;
                            this.warnings = res.data.Data.Warnings || [];
                            this.info = res.data.Data.Employee;
                            this.sgkExitNotice.NotifyDate = res.data.Data.Employee?.WaitingExitDate ? moment(res.data.Data.Employee.WaitingExitDate, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD") : null;
                            this.sgkExitNotice.istenCikisTarihi = res.data.Data.Employee?.WaitingExitDate
                                ? moment(res.data.Data.Employee.WaitingExitDate, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD")
                                : null;
                            this.sgkEntryNotice.ozurlu = res.data.Data?.Employee?.DisabledPerson || false;
                            this.otherInfo.EmployeeRelativeInformations = res.data.Data.EmployeeRelatives ? res.data.Data.EmployeeRelatives : [];
                            this.otherInfo.EmployeeAddresses = res.data.Data.EmployeeAddresses ? res.data.Data.EmployeeAddresses : [];
                            this.otherInfo.EmployeeBankAccounts = res.data.Data.EmployeeBankAccounts ? res.data.Data.EmployeeBankAccounts : [];
                            this.otherInfo.EmployeeContactInfos = res.data.Data.EmployeeContactInfos ? res.data.Data.EmployeeContactInfos : [];
                            this.otherInfo.EmployeeSizeInformations = res.data.Data.EmployeeSizeInformations ? res.data.Data.EmployeeSizeInformations : [];
                            this.otherInfo.EducationsOfEmployee = res.data.Data.EducationInfos ? res.data.Data.EducationInfos : [];
                            this.otherInfo.MilitaryTitlesOfEmployee = res.data.Data.MilitaryTitlesOfEmployee
                                ? res.data.Data.MilitaryTitlesOfEmployee.map((m) => {
                                      return {
                                          ...m,
                                          StartDateVisual: moment(m.StartDate).locale("tr").format("L"),
                                          EndDateVisual: moment(m.EndDate).locale("tr").format("L"),
                                      };
                                  })
                                : [];
                            this.otherInfo.Passports = res.data.Data.Passports
                                ? res.data.Data.Passports.map((p) => {
                                      return {
                                          ...p,
                                          EndDateVisual: moment(p.EndDate).locale("tr").format("L"),
                                      };
                                  })
                                : [];
                            this.otherInfo.Visas = res.data.Data.Visas
                                ? res.data.Data.Visas.map((v) => {
                                      return {
                                          ...v,
                                          EndDateVisual: moment(v.EndDate).locale("tr").format("L"),
                                          StartDateVisual: moment(v.StartDate).locale("tr").format("L"),
                                      };
                                  })
                                : [];
                            this.driverLicenseInfo = res.data.Data.EmployeeDriverLicense ? res.data.Data.EmployeeDriverLicense : null;
                            /* SALARY START*/
                            this.netSalary.CreateTime = res.data.Data.EmployeeNetSalary[0]?.CreateTime || null;
                            this.netSalary.Date = res.data.Data.EmployeeNetSalary[0]?.Date ? moment(res.data.Data.EmployeeNetSalary[0].Date, "DD.MM.YYYY").format("YYYY-MM-DD") : null;
                            this.netSalary.Month = res.data.Data.EmployeeNetSalary[0]?.Month || null;
                            this.netSalary.Year = res.data.Data.EmployeeNetSalary[0]?.Year || null;
                            this.netSalary.SGK = res.data.Data.EmployeeNetSalary[0]?.SGK || null;
                            this.netSalary.Salary = res.data.Data.EmployeeNetSalary[0]?.Salary || null;
                            this.netSalary.SalaryStr = res.data.Data.EmployeeNetSalary[0]?.SalaryStr || null;
                            this.netSalary.CurrencyUnitId = res.data.Data.EmployeeNetSalary[0]?.CurrencyUnitId || null;
                            this.netSalary.CurrencyUnitName = res.data.Data.EmployeeNetSalary[0]?.CurrencyUnitName || null;
                            this.netSalary.CurrencyUnitCurrencyCode = res.data.Data.EmployeeNetSalary[0]?.CurrencyUnitCurrencyCode || null;
                            this.netSalary.UCRET_NEVI = res.data.Data.EmployeeNetSalary[0]?.UCRET_NEVI || null;
                            this.netSalary.SalaryTypeName = res.data.Data.EmployeeNetSalary[0]?.SalaryTypeName || null;
                            this.netSalary.IsMinimumWage = res.data.Data.EmployeeNetSalary[0]?.ASGARI_UCRETLI || null;

                            this.sgkSalary.CreateTime = res.data.Data.EmployeeSGKSalary[0]?.CreateTime || null;

                            this.sgkSalary.Date = res.data.Data.EmployeeSGKSalary[0]?.Date
                                ? moment([res.data.Data.EmployeeSGKSalary[0].Month, res.data.Data.EmployeeSGKSalary[0].Year], "M.YYYY").format("YYYY-MM-DD")
                                : null;

                            this.sgkSalary.Month = res.data.Data.EmployeeSGKSalary[0]?.Month || null;
                            this.sgkSalary.Year = res.data.Data.EmployeeSGKSalary[0]?.Year || null;
                            this.sgkSalary.SGK = res.data.Data.EmployeeSGKSalary[0]?.SGK || null;
                            this.sgkSalary.Salary = res.data.Data.EmployeeSGKSalary[0]?.Salary || null;
                            this.sgkSalary.SalaryStr = res.data.Data.EmployeeSGKSalary[0]?.SalaryStr || null;
                            this.sgkSalary.CurrencyUnitId = res.data.Data.EmployeeSGKSalary[0]?.CurrencyUnitId || null;
                            this.sgkSalary.CurrencyUnitName = res.data.Data.EmployeeSGKSalary[0]?.CurrencyUnitName || null;
                            this.sgkSalary.CurrencyUnitCurrencyCode = res.data.Data.EmployeeSGKSalary[0]?.CurrencyUnitCurrencyCode || null;
                            this.sgkSalary.UCRET_NEVI = res.data.Data.EmployeeSGKSalary[0]?.UCRET_NEVI || null;
                            this.sgkSalary.SalaryTypeName = res.data.Data.EmployeeSGKSalary[0]?.SalaryTypeName || null;
                            this.sgkSalary.IsMinimumWage = res.data.Data.EmployeeSGKSalary[0]?.ASGARI_UCRETLI || null;

                            this.salary = {
                                net: this.netSalary,
                                sgk: this.sgkSalary,
                            };

                            this.salaries = {
                                net: res.data.Data.EmployeeSGKSalary || [],
                                sgk: res.data.Data.EmployeeSGKSalary || [],
                            };
                            // this.salary.NetSalary = res.data.Data.EmployeeSalary[0]?.NetSalary || null
                            // this.salary.IsNetMinimumWage = res.data.Data.EmployeeSalary[0]?.IsNetMinimumWage || false
                            // this.salary.NetSalaryStr = res.data.Data.EmployeeSalary[0]?.NetSalaryStr || null
                            // this.salary.NetSalaryCurrencyUnitId = res.data.Data.EmployeeSalary[0]?.NetSalaryCurrencyUnitId || null
                            // this.salary.NetSalaryTypeId = res.data.Data.EmployeeSalary[0]?.NetSalaryTypeId || null
                            // this.salary.NetDateStr = res.data.Data.EmployeeSalary[0]?.NetDate || null
                            // this.salary.NetDate = res.data.Data.EmployeeSalary[0]?.NetDate ? moment(res.data.Data.EmployeeSalary[0].NetDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
                            // this.salary.SGKSalary = res.data.Data.EmployeeSalary[0]?.SGKSalary || null
                            // this.salary.IsSGKMinimumWage = res.data.Data.EmployeeSalary[0]?.IsSGKMinimumWage || false
                            // this.salary.SGKSalaryStr = res.data.Data.EmployeeSalary[0]?.SGKSalaryStr || null
                            // this.salary.SGKSalaryCurrencyUnitId = res.data.Data.EmployeeSalary[0]?.SGKSalaryCurrencyUnitId || null
                            // this.salary.SGKSalaryTypeId = res.data.Data.EmployeeSalary[0]?.SGKSalaryTypeId || null
                            // this.salary.SGKDateStr = res.data.Data.EmployeeSalary[0]?.SGKDate || null
                            // this.salary.SGKDate = res.data.Data.EmployeeSalary[0]?.SGKDate ? moment(res.data.Data.EmployeeSalary[0]?.SGKDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
                            /* SALARY END*/
                            /* BUSINESS AGREEMENT START */
                            this.businessAgreement.SGKBranchId = res.data.Data.BusinessAgreement?.SGKBranch?.Id || null;
                            this.businessAgreement.EmployeeDepartmentTitleId = res.data.Data.BusinessAgreement?.EmployeeDepartmentTitle?.Id || null;
                            this.businessAgreement.ExpenseLocationId = res.data.Data.BusinessAgreement?.ExpenseLocation?.Id || null;
                            this.businessAgreement.CollarStatusId = res.data.Data.BusinessAgreement?.CollarStatus?.Id || null;
                            this.businessAgreement.CollarStatusCode = res.data.Data.BusinessAgreement?.CollarStatus?.Code || null;
                            this.businessAgreement.RegistrationCode = res.data.Data.BusinessAgreement?.RegistrationCode || null;
                            this.businessAgreement.SGKRegistryNumber = res.data.Data.BusinessAgreement?.SGKRegistryNumber || null;
                            this.businessAgreement.GarageSalaryString = res.data.Data.BusinessAgreement?.GarageSalaryString || null;
                            this.businessAgreement.SGKInsuranceType = res.data.Data.BusinessAgreement?.SGKInsuranceType || null;
                            this.businessAgreement.BES = res.data.Data.BusinessAgreement?.BES || null;
                            this.businessAgreement.BESLastCheck = res.data.Data.BusinessAgreement?.BESLastCheck || null;
                            this.businessAgreement.Yol = res.data.Data.BusinessAgreement?.Yol || false;
                            this.businessAgreement.Yemek = res.data.Data.BusinessAgreement?.Yemek || false;
                            this.businessAgreement.Destek = res.data.Data.BusinessAgreement?.Destek || false;
                            this.businessAgreement.DestekAmount = res.data.Data.BusinessAgreement?.DestekAmount || false;
                            this.sgkEntryNotice.sigortalituru = res.data.Data.BusinessAgreement?.SGKInsuranceType || null;
                            /* BUSINESS AGREEMENT END */
                            /* SGKINFOS START */
                            this.sgkEntry = res.data.Data.SGKEntry;
                            if (this.sgkEntry != null) {
                                this.sgkExitNotice.branchId = this.sgkEntry.SGKBranch?.Id || null;
                            }
                            /* SGKINFOS END */
                            /* BRANCH START */
                            this.employeeBranch.Id = res.data.Data.EmployeeBranch?.Id || null;
                            this.employeeBranch.Current = res.data.Data.EmployeeBranch || null;
                            this.employeeBranch.BranchId = res.data.Data.EmployeeBranch?.Branch?.Id || null;
                            this.employeeBranch.EmployeeDepartmentTitleId = res.data.Data.EmployeeBranch?.EmployeeDepartmentTitle?.Id || null;
                            this.employeeBranch.VehicleInventoryGarageId = res.data.Data.EmployeeBranch?.VehicleInventoryGarage?.Id || null;
                            this.employeeBranch.ChangeType = 0;
                            this.employeeBranch.BranchStartDate = res.data.Data.EmployeeBranch?.BranchStartDate || null;
                            this.employeeBranch.TitleStartDate = res.data.Data.EmployeeBranch?.TitleStartDate || null;
                            this.employeeBranch.GarageStartDate = res.data.Data.EmployeeBranch?.GarageStartDate || null;
                            /* BRANCH END */
                            this.loading = false;
                            this.viewedInfo = {
                                FirstName: res.data.Data.Employee.FirstName,
                                LastName: res.data.Data.Employee.LastName,
                                RegistrationCode: res.data.Data.Employee.RegistrationCode,
                                File: res.data.Data.Employee.File,
                                HasUser: res.data.Data.Employee.HasUser,
                                IdentityNumber: res.data.Data.Employee.IdentityNumber,
                                CollarStatus: res.data.Data.BusinessAgreement.CollarStatus,
                            };
                            this.aktifNetsisSube = res.data.Data.AktifNetsisSube;
                            this.businessAgreement.RegistrationCode = res.data.Data.Employee.RegistrationCode;
                            if (res.data.Data.EmployeeNetsisModel) {
                                this.netsis = res.data.Data.EmployeeNetsisModel;
                            }
                            this.netsis.ASGARI_UCRETLI = res.data.Data.EmployeeNetSalary[0]?.IsMinimumWage || "H";
                        } catch (err) {
                            if (res.data.Message) {
                                this.result(null, res);
                            }
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },
        getOtherInfoTitle(title) {
            if (this.controlUnsavedChanges.Total > 0) return [title, "*"].join("");
            else return title;
        },
        back() {
            if (this.isCandidate) {
                this.$router.push({ name: "employee", query: { tab: "candidates" } });
                return;
            }
            if (this.$route.query?.from == "departments") {
                this.$router.push({ name: "hr-employee-department" });
            } else this.$router.push({ name: "employee" });
        },
        getCandidate() {
            if (this.id == "0" || this.id == 0) return;
            this.loading = true;
            EmployeeOperationsApi.Employee.Candidate.Get(this.id)
                .then((res) => {
                    try {
                        const op = res.data.Data.Operation || {};
                        const profilePhotoUrl = res.data.Data.ProfilePhotoUrl || null;
                        this.employeeLoaded = true;
                        // Step 1 - Özlük
                        if (op.EmployeeInformation) {
                            this.info = { ...this.info, ...op.EmployeeInformation, File: profilePhotoUrl };
                        }
                        // Step 2 - Diğer özlük
                        this.otherInfo.EmployeeRelativeInformations = op.EmployeeRelativeInformations || [];
                        this.otherInfo.EmployeeAddresses = op.EmployeeAddresses || [];
                        this.otherInfo.EmployeeBankAccounts = op.EmployeeBankAccounts || [];
                        this.otherInfo.EmployeeContactInfos = op.EmployeeContactInfos || [];
                        this.otherInfo.EmployeeSizeInformations = op.EmployeeSizeInformations || [];
                        this.otherInfo.EducationsOfEmployee = op.EducationsOfEmployee || [];
                        this.otherInfo.MilitaryTitlesOfEmployee = op.MilitaryTitlesOfEmployee || [];
                        this.otherInfo.Passports = op.Passports || [];
                        this.otherInfo.Visas = op.Visas || [];
                        // Step 3 - Ehliyet
                        if (op.EmployeeDriverLicenseInformation) {
                            this.driverLicenseInfo = op.EmployeeDriverLicenseInformation;
                        }
                        // Step 6 - İş sözleşmesi (aday aşamasında sadece sözleşme alanları)
                        if (op.BusinessAgreement) {
                            this.businessAgreement = { ...this.businessAgreement, ...op.BusinessAgreement };
                        }
                        this.viewedInfo = {
                            FirstName: this.info.FirstName,
                            LastName: this.info.LastName,
                            RegistrationCode: null,
                            File: profilePhotoUrl,
                            HasUser: false,
                            IdentityNumber: this.info.IdentityNumber,
                            CollarStatus: null,
                        };
                        this.loading = false;
                    } catch (err) {
                        this.loading = false;
                        if (res.data.Message) {
                            this.$result(null, res);
                        }
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$result(null, err);
                });
        },
        convertToEmployee() {
            this.$confirm(
                "Gerçek personele dönüştürülsün mü?",
                "Bu aday gerçek personele dönüştürülecek ve artık aday listesinde düzenlenemeyecektir."
            ).then((c) => {
                if (!c) return;
                this.converting = true;
                EmployeeOperationsApi.Employee.Candidate.Convert(this.id)
                    .then((res) => {
                        this.$result(res);
                        this.converting = false;
                        if (res.data.Success && res.data.Data && res.data.Data.Id) {
                            this.$router.push({ name: "employee-create-or-update", params: { id: res.data.Data.Id } });
                        }
                    })
                    .catch((err) => {
                        this.converting = false;
                        this.$result(null, err);
                    });
            });
        },
        exitDone(bool) {
            this.sgkExitNotice.istenCikisTarihi = null;
            this.sgkExitNotice.IhbarOneliKullanacak = false;
            this.sgkExitNotice.NotifyDate = null;
            this.sgkExitNotice.Mediation = null;
            this.sgkExitNotice.Agreed = null;
            this.sgkExitNotice.PaymentDeadline = null;
            this.sgkExitNotice.PaymentAmount = null;
            this.sgkExitNotice.Description = null;
            this.sgkExitNotice.JobExitCauseCode = null;
            this.sgkExitNotice.JobExitCauseId = null;
            if (bool) {
                this.getPersonal();
                this.$refs.docs?.refresh();
            }
        },
        createSystemUser() {
            this.userCreating = true;
            UserApi.EmployeeUser({
                EmployeeId: this.id,
                RoleGroupId: this.systemUser.RoleGroupId,
            })
                .then((res) => {
                    this.$result(res);
                    this.userCreating = false;
                    if (res.data.Success) {
                        this.getPersonal();
                        this.$hideModal("create-system-user");
                    }
                })
                .catch((err) => {
                    this.userCreating = false;
                    this.$result(null, err);
                });
        },
        showWarning() {
            this.$showModal("warnings");
        },
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        editing() {
            return this.$route.params.id != 0 || this.$route.params.id != "0" ? true : false;
        },
        isCandidate() {
            return this.$route.meta && this.$route.meta.candidate === true;
        },
        showEmailWarning() {
            const isWhiteCollar = this.businessAgreement.CollarStatusCode === 'White'
            if(!isWhiteCollar) return false
            
            const hasDefaultEmail = this.otherInfo.EmployeeContactInfos.some(
                c => c.ContactTypeKey === 'EMAIL' && c.IsDefault && c.Value
            )
            
            return !hasDefaultEmail
        },
        controlUnsavedChanges() {
            let changeCountOfEmployeeRelativeInformations = this.otherInfo.EmployeeRelativeInformations.filter((i) => i?.Unsaved).length;
            let changeCountOfEmployeeAddresses = this.otherInfo.EmployeeAddresses.filter((i) => i?.Unsaved).length;
            let changeCountOfEmployeeSizeInformations = this.otherInfo.EmployeeSizeInformations.filter((i) => i?.Unsaved).length;
            let changeCountOfEmployeeBankAccounts = this.otherInfo.EmployeeBankAccounts.filter((i) => i?.Unsaved).length;
            let changeCountOfEmployeeContactInfos = this.otherInfo.EmployeeContactInfos.filter((i) => i?.Unsaved).length;
            let changeCountOfPassports = this.otherInfo.Passports.filter((i) => i?.Unsaved).length;
            let changeCountOfVisas = this.otherInfo.Visas.filter((i) => i?.Unsaved).length;
            let changeCountOfEducations = this.otherInfo.EducationsOfEmployee.filter((i) => i?.Unsaved).length;

            let total =
                changeCountOfEmployeeRelativeInformations +
                changeCountOfEmployeeAddresses +
                changeCountOfEmployeeSizeInformations +
                changeCountOfEmployeeBankAccounts +
                changeCountOfEmployeeContactInfos +
                changeCountOfPassports +
                changeCountOfVisas +
                changeCountOfEducations;

            return {
                EmployeeRelativeInformations: changeCountOfEmployeeRelativeInformations,
                EmployeeAddresses: changeCountOfEmployeeAddresses,
                EmployeeSizeInformations: changeCountOfEmployeeSizeInformations,
                EmployeeBankAccounts: changeCountOfEmployeeBankAccounts,
                EmployeeContactInfos: changeCountOfEmployeeContactInfos,
                Passports: changeCountOfPassports,
                Visas: changeCountOfVisas,
                EducationsOfEmployee: changeCountOfEducations,
                Total: total,
            };
        },
        canEntry() {
            if (this.sgkEntry != null) {
                return this.sgkEntry.Exit == null ? false : true;
            } else return true;
        },
        canExit() {
            if (this.sgkEntry != null) {
                return this.sgkEntry.Exit == null ? true : false;
            } else return false;
        },
        hasWarning() {
            return (this.warnings || []).length > 0 ? true : false;
        },
        isDriver() {
            return this.employeeBranch?.Current?.EmployeeDepartmentTitle?.DriverDepartment || false;
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.controlUnsavedChanges.Total > 0) {
            this.$confirm(
                "Çıkmak istediğinize emin misiniz?",
                "Diğer Özlük Bilgileri sayfası çoklu düzenleme, ekleme ve silme işlemleri yapar. Bu sayfada kaydedilmemiş değişiklikleriniz bulunmaktadır. Devam durumunda değişiklikler kaydedilmeyecektir."
            ).then((result) => {
                if (result) {
                    next();
                } else {
                    next(false);
                }
            });
        } else next();
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
.custom-nav .nav-link {
    margin: 0.25rem;
}
.custom-nav .nav-link:not(.active) {
    border: 1px solid hsl(222, 17%, 85%);
    background-color: #ffffff;
}

.dark-layout .custom-nav .nav-link:not(.active) {
    border: 1px solid hsl(222, 17%, 40%);
    background-color: #283046;
}
</style>
